import { cn } from '@/lib/utils/ui'

export const editorPageRailClassName = cn(
  'mx-auto w-full max-w-7xl px-6',
)

export const editorPageWorkspaceClassName = cn(
  'mx-auto flex w-full min-w-0 flex-col gap-6',
  'xl:flex-row xl:items-start xl:gap-10',
)
